const route = {
	path: '/accouting-accounts-report',
	name: 'accouting-accounts-report',
	meta: {
		title: 'Reportes por Asignar',
	},
	component: () => import('@/pages/company-templates/page-templates'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/company-templates.js